export enum UserRole {
  SUPER_ADMIN = 'super-admin',
  READ_ADMIN = 'read-admin',
  SUPPORT_ADMIN = 'support-admin',
  ORG_ADMIN = 'org-admin',
  USER = 'user',
}
